// eslint-disable-next-line import/prefer-default-export
export const getCreateForm = ((state) => state.createform.type)
export const updateForm = ((state) => state.createform.isUpdate)
export const indexForm = ((state) => state.createform.index)
export const loadingBt = ((state) => state.createform.loading)
export const storeData = ((state) => state.createform.storeData)
export const listData = ((state) => state.createform.listData)
export const arrStore = ((state) => state.createform.arrObjStore)
export const listDoc = ((state) => state.createform.dataDocId)
